//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    position: absolute;
    top: 16px;
    right: 16px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    transition: 0.35s;
    cursor: pointer;
    & svg {
        width: ${({ size }) => size || "unset"};
        height: ${({ size }) => size || "unset"};
    }
    &:hover {
        background-color: #00000013;
    }
`;